import { render } from "./maindashboard.vue?vue&type=template&id=3312b93c&scoped=true"
import script from "./maindashboard.vue?vue&type=script&lang=js"
export * from "./maindashboard.vue?vue&type=script&lang=js"

import "./maindashboard.vue?vue&type=style&index=0&id=3312b93c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3312b93c"]])

export default __exports__